import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { DateTime, Interval } from "luxon";

export const getDefaultEventInterval = (durationMins = 30) =>
  Interval.fromDateTimes(
    DateTime.now().setZone(getRenderTimeZone()).startOf("hour"),
    DateTime.now().setZone(getRenderTimeZone()).startOf("hour").plus({ minutes: durationMins }),
  );
